var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAboutArrow = function SvgAboutArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20c22.091 0 40 17.909 40 40H40C17.909 40 0 22.091 0 0Z",
    fill: "#395AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32.747 14.909-.088-.476-.479.073-.286.043-.015.003-.015.003-.136.029-.135.029-.477.102.09.48c.364 1.93 1.21 3.206 2.188 4.043H21.5v1.538h11.887c-1.011.839-1.876 2.122-2.198 4.055l-.083.5.501.076.277.042.141.027.02.004.021.003.136.014.47.05.077-.467c.314-1.934 1.263-2.978 2.242-3.56.987-.587 2.04-.72 2.583-.743.257.013.47 0 .426 0h.561l-.064-.558-.012-.102v-.034l.014-.338.023-.521H37.411c-.603-.035-1.596-.193-2.517-.789-.91-.588-1.794-1.63-2.147-3.526ZM38 20.073v-.297.297Z",
    fill: "#fff",
    stroke: "#fff"
  })));
};
export default SvgAboutArrow;